var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inactive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00262703,18 L4,18 L4,17.9980254 C1.57968754,16.1782233 0.00968152459,13.284904 4.43431211e-05,10.0250628 C-0.00962980637,6.74841723 1.5643576,3.8327359 4,2.00204599 L4,2 L4.00272305,2 C5.67358082,0.745026968 7.74959317,0.000508698275 9.99785684,2.88639408e-07 C12.2478119,-0.00053513571 14.3254839,0.743863804 15.997421,2 L16,2 L16,2.0019383 C18.4250616,3.82511983 19.9958568,6.72518257 19.9994818,9.99000029 C20.0031153,13.2614451 18.4311881,16.1699504 16,17.9972333 L16,18 L15.9963172,18 C14.329782,19.2513743 12.2599505,19.9948902 10.0172943,19.9994378 C7.76206168,20.0039879 5.67863808,19.2593134 4.00262703,18 Z",
    id: "Combined-Shape",
    fill: "#9AADAD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 7,
    y: 7,
    width: 6,
    height: 6,
    rx: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.c25e8863b9024450695e6e6ad96aa609.svg";
export { ForwardRef as ReactComponent };